import type { Absence } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import { ABSENCES_QUERY_KEY, ABSENCES_URL } from './queryConstants'

type UseAbsencesListProps = {
  users?: [string | undefined]
  absenceType?: string
  startDate?: string
  endDate?: string
  otherFilterParams?: Record<string, any>
}

type UseAbsencesListReturn = {
  absences: Absence[]
  isAbsencesLoading: boolean
  refetch: () => void
}

export const useAbsencesList = ({
  users,
  absenceType,
  startDate,
  endDate,
  otherFilterParams = {}
}: UseAbsencesListProps): UseAbsencesListReturn => {
  const absencesQueryParams = getQueryParams({
    dateRange: [
      dayjs(startDate).startOf('day').toISOString(),
      dayjs(endDate).endOf('day').toISOString()
    ],
    users,
    absenceType,
    ...otherFilterParams
  })

  const {
    data: absencesData,
    isLoading: isAbsencesLoading,
    refetch
  } = useQuery(
    [ABSENCES_QUERY_KEY, absencesQueryParams],
    () =>
      getJSON({
        url: `${ABSENCES_URL}?${absencesQueryParams}`,
        isRota: true
      }),
    { enabled: true }
  )

  return {
    absences: (absencesData?.data || []) as Absence[],
    isAbsencesLoading,
    refetch
  }
}
